// Stockholders State

export default {
  stockholdersList: [],
  stockholderInfo: {}
}
